export default __webpack_public_path__ + "static/usa_texas_two_step-c94c46216315a606204ffde794c5082b.png";